export function speakText(text: string, languageCode: string): void {
  if (!("speechSynthesis" in window)) {
    throw new Error("Bu tarayıcı sesli okumayı desteklemiyor.");
  }

  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = languageCode;
  utterance.rate = 0.88;
  utterance.pitch = 1;

  const voices = window.speechSynthesis.getVoices();
  const exactVoice = voices.find(
    (voice) => voice.lang.toLocaleLowerCase() === languageCode.toLocaleLowerCase(),
  );
  const baseLanguage = languageCode.split("-")[0].toLocaleLowerCase();
  const fallbackVoice = voices.find((voice) =>
    voice.lang.toLocaleLowerCase().startsWith(baseLanguage),
  );

  utterance.voice = exactVoice ?? fallbackVoice ?? null;
  window.speechSynthesis.speak(utterance);
}

